import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#f0ebe3] text-brand-anthracite">
      {/* Gold divider */}
      <div className="h-px w-full" style={{ background: 'linear-gradient(90deg, transparent, #c9a227, transparent)' }} />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/59e36d2c26ecf2260a04bff1d16ab4f7.png"
              alt="Ev & Co Design"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-sm text-brand-gray leading-relaxed mb-6">
              Agence de décoration haut de gamme à Abidjan. Nous transformons vos espaces et événements en expériences inoubliables depuis 2019.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/evcodesign.ci?igsh=emZmeWx2NXdmMmw1&utm_source=qr"
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-brand-fuchsia hover:bg-brand-fuchsia hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href="tel:+2250718624706"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-brand-coral hover:bg-brand-coral hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-phone-line text-base" />
              </a>
              <a
                href="mailto:hello@evcodesign-ci.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-brand-anthracite hover:bg-brand-anthracite hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-serif text-base font-semibold text-brand-anthracite mb-5 pb-3 border-b border-brand-gold/30">
              Services
            </h3>
            <ul className="space-y-3">
              {[
                { label: 'Décoration Événementiel', path: '/decoration-evenementielle' },
                { label: "Décoration d'Intérieur", path: '/decoration-interieur' },
                { label: 'Création 3D', path: '/creation-3d' },
                { label: 'Conseil', path: '/conseil' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-brand-gray hover:text-brand-coral transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-serif text-base font-semibold text-brand-anthracite mb-5 pb-3 border-b border-brand-gold/30">
              Navigation
            </h3>
            <ul className="space-y-3">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'À propos', path: '/a-propos' },
                { label: 'Galerie / Portfolio', path: '/galerie' },
                { label: 'Contact / Devis', path: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-brand-gray hover:text-brand-coral transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-base font-semibold text-brand-anthracite mb-5 pb-3 border-b border-brand-gold/30">
              Contact
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-brand-coral text-sm" />
                </div>
                <span className="text-sm text-brand-gray">Cocody, Riviera 4, Abidjan, Côte d&apos;Ivoire</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-brand-coral text-sm" />
                </div>
                <a href="tel:+2250718624706" className="text-sm text-brand-gray hover:text-brand-coral transition-colors">
                  +225 07 18 62 47 06
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-brand-coral text-sm" />
                </div>
                <a href="mailto:hello@evcodesign-ci.com" className="text-sm text-brand-gray hover:text-brand-coral transition-colors">
                  hello@evcodesign-ci.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-brand-coral text-sm" />
                </div>
                <div>
                  <p className="text-sm text-brand-gray">Lun – Ven : 9h00 – 18h30</p>
                  <p className="text-sm text-brand-gray">Sam : 9h00 – 13h00</p>
                  <p className="text-sm text-brand-gray">Dim : Fermé</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-brand-gold/20">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-brand-gray">
            © {new Date().getFullYear()} Ev &amp; Co Design. Tous droits réservés.
          </p>
          <p className="text-xs text-brand-gray">
            <a
              href="https://alphasolutions237.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-brand-coral transition-colors duration-200 cursor-pointer"
            >
              Powered By Alpha Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
